import { useEffect, useState } from "react";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useAppStore } from "@/stores/RootStore";
import { Separator } from "@/ui/Separator";
import { Header } from "@/components/Header";
import { DowntimesType } from "@/types/types";
import { useFetch } from "@/hooks/useFetch";
import Spinner from "@/ui/Spinner/Spinner";

import DowntimesGrid from "./DowntimesGrid";

export const Downtimes = () => {
  let { id } = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite;

  const [loading, setLoading] = useState(true);
  const [{ response, isLoading, error }, doFetchItem] = useFetch(
    `/administration/directories/downtime_reasons`,
    true,
  );
  const [downtimes, setDowntimes] = useState<DowntimesType[]>();

  useEffect(() => {
    setLoading(true);
    doFetchItem();
  }, []);

  useEffect(() => {
    if (!response) {
      return;
    }
    setDowntimes(response as unknown as DowntimesType[]);
    setLoading(false);
  }, [response]);

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}>
            <span className="font-medium">
              {currentSite?.name ? currentSite?.name : "..."}
            </span>
          </NavLink>
          <span>/</span>
          <NavLink to={"/admin"}>
            <span className="font-medium">{t("admin")}</span>
          </NavLink>
          <span>/</span>
          {location.pathname == "/admin/downtimes/" ||
          location.pathname == "/admin/downtimes" ? (
            <span>{t("downtime_reasons")}</span>
          ) : (
            <NavLink to={"/admin/downtimes"}>
              <span>{t("downtime_reasons")}</span>
            </NavLink>
          )}
          {(id || location.pathname == "/admin/downtimes/new") && (
            <span>/</span>
          )}
          {id && <span>{downtimes?.find((n) => n.id == id)?.name}</span>}
          {location.pathname == "/admin/downtimes/new" && (
            <span>{t("adding_downtime_reason")}</span>
          )}
        </div>
      </div>
      <Separator className="flex-none" />
      {id || location.pathname == "/admin/downtimes/new" ? (
        <Outlet context={[downtimes, setDowntimes]} />
      ) : (
        <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
          <Header
            name={t("downtime_reasons")}
            backName={t("admin")}
            backLink={"/admin"}
          />
          {loading ? (
            <Spinner />
          ) : (
            <DowntimesGrid downtimes={downtimes!} onClose={empty} />
          )}
        </div>
      )}
    </div>
  );
};
